<template>
    <div class="language-choice">
        <button @click="handleOnClickBtn()" type="button" :class="['btn', 'language', {active: isActiveDropdown}]">
            <img v-if="isBlackBackground"  src="./images/icon_08.svg" alt="">
            <img v-else  src="./images/icon_08_02.svg" alt="">
        </button>
        <transition name="la-menu">
            <ul class="la-menu" v-if="isActiveDropdown">
                <li v-for="language in languages"
                    @click="setLanguage(language)"
                    :class="[{active: language.code === activeLanguage}]">
                    <span>{{ $t(language.code) }}</span>
                </li>
            </ul>
        </transition>
    </div>
</template>

<script>
    import JSCookie from 'js-cookie';
    import languageService from "../../services/LanguageService";
    import AuthUtil from "../../utils/AuthUtil";

    export default {
        name: 'language-choice',

        mounted() {
            this.isAuth = AuthUtil.isAuth();
        },

        data() {
            return {
                languages: [],
                isActiveDropdown: false,
                activeLanguage: languageService.getCurrentLanguageCode(),
                isBlackBackground: false,
            }
        },

        props: {
            isFixed:{
                type: Boolean,
            }
        },

        watch: {
            isFixed: function (val, oldVal) {
                if (this.$route.name === 'home') {
                    this.isBlackBackground = !val;
                }
            },
            $route (to, from) {
                this.isBlackBackground = (this.$route.name === 'home' && !this.isFixed);
                this.setMetaTitle(to.meta.titleKey)
                this.isActiveDropdown = false;
                if (this.$route.name === 'home') {
                    if (window.matchMedia( "(max-width: 991px)" ).matches) {
                        this.isBlackBackground = false //PCの場合
                    }else{
                        this.isBlackBackground = true　//PC以外の場合
                    }
                }else{
                    this.isBlackBackground = false
                }
            }
        },

        methods: {
            handleOnClickBtn() {
                this.isActiveDropdown = !this.isActiveDropdown
            },

            async setLanguage(language) {
                this.isActiveDropdown = false;
                this.$i18n.locale = language.code;
                this.activeLanguage = language.code;
                JSCookie.set('app_locale', language.code);
                if (this.isAuth) {
                    languageService.updateUserLanguageCode(language.code);
                }
                this.setMetaTitle(this.$route.meta.titleKey)
            },

            async fetchLanguages() {
                const response = await languageService.getLanguageCodes();
                this.languages = response.data;
            },

            setMetaTitle(titleKey) {
                const appName = this.$i18n.t('appName')
                if (titleKey) {
                    // 学習コンテンツのみIDを付与
                    if (titleKey === 'studies.title.') {
                        titleKey += this.$route.query.id;
                    }
                    const tTitle = this.$i18n.t(titleKey)
                    document.title = `${tTitle} | ${appName}`
                    return
                }
                document.title = appName
            }
        },

        created() {
            this.fetchLanguages();
            if (this.$route.name === 'home' && !this.isFixed) {
                this.isBlackBackground = true;
            }
            this.setMetaTitle(this.$route.meta.titleKey)
        }
    }
</script>

<style lang="scss">
    .la-menu-enter-active, .la-menu-leave-active {
        transition: opacity .5s;
    }
    .la-menu-enter, .la-menu-leave-to /* .la-menu-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
</style>
